(() => {
 'use strict';
 const realDocument=document, realWindow=window;
 const mounted=new Map();
 function mount(root){
  if(mounted.has(root))return;
  let alive=true;const abort=new AbortController(), disposers=[], intervals=new Set(), frames=new Set(), timeouts=new Set();
  const listen=(target,type,fn,options={})=>{target.addEventListener(type,fn,{...options,signal:abort.signal});};
  const document=new Proxy(realDocument,{get(target,key){
   if(key==='querySelector')return selector=>selector==='.site-header'?realDocument.querySelector(selector):root.querySelector(selector);
   if(key==='querySelectorAll')return selector=>root.querySelectorAll(selector);
   if(key==='addEventListener')return (type,fn,options)=>listen(target,type,fn,options);
   const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value;
  }});
  const window=new Proxy(realWindow,{get(target,key){
   if(key==='addEventListener')return(type,fn,options)=>listen(target,type,fn,options);
   if(key==='setInterval')return(fn,delay)=>{const id=realWindow.setInterval(()=>{if(alive)fn();},delay);intervals.add(id);return id;};
   if(key==='setTimeout')return(fn,delay)=>{const id=realWindow.setTimeout(()=>{timeouts.delete(id);if(alive)fn();},delay);timeouts.add(id);return id;};
   if(key==='requestAnimationFrame')return fn=>{const id=realWindow.requestAnimationFrame(time=>{frames.delete(id);if(alive)fn(time);});frames.add(id);return id;};
   if(key==='matchMedia')return query=>{const media=realWindow.matchMedia(query);return new Proxy(media,{get(m,k){if(k==='addEventListener')return(type,fn)=>listen(m,type,fn);const v=Reflect.get(m,k,m);return typeof v==='function'?v.bind(m):v;}});};
   const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value;
  }});
  const ResizeObserver=realWindow.ResizeObserver?class extends realWindow.ResizeObserver{constructor(callback){super((...args)=>{if(alive)callback(...args);});disposers.push(()=>this.disconnect());}}:undefined;
  const IntersectionObserver=realWindow.IntersectionObserver?class extends realWindow.IntersectionObserver{constructor(callback,options){super((...args)=>{if(alive)callback(...args);},options);disposers.push(()=>this.disconnect());}}:undefined;
  function syncBuybarModalState(){realWindow.lsaSyncModal?.();}
  function initShippingBar() {
    var bar = document.querySelector('.utility-bar');
    if (!bar) return;
    function updateHeight() {
      document.documentElement.style.setProperty('--utility-bar-height', bar.getBoundingClientRect().height + 'px');
    }
    updateHeight();
    if ('ResizeObserver' in window) new ResizeObserver(updateHeight).observe(bar);
    else window.addEventListener('resize', updateHeight);
  }

  function initScrollHero() {
    var hero = document.querySelector('[data-scroll-hero]');
    if (!hero) return;
    var stage = hero.querySelector('.selected-hero__stage');
    var visual = hero.querySelector('.selected-hero__visual');
    var cluster = hero.querySelector('.selected-hero__cluster');
    var head = hero.querySelector('.selected-hero__head');
    var blockedHead = hero.querySelector('.selected-hero__airway');
    var clearHead = hero.querySelector('.hero-head__clear');
    var settledHead = hero.querySelector('.hero-head__settled');
    var ball = hero.querySelector('.hero-obstruction');
    var device = hero.querySelector('.selected-hero__device');
    var rig = hero.querySelector('.hero-device-rig');
    var whole = hero.querySelector('.hero-device__whole');
    var plunger = hero.querySelector('.hero-device__plunger');
    var body = hero.querySelector('.hero-device__body');
    var header = document.querySelector('.site-header');
    var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!stage || !visual || !cluster || !head || !blockedHead || !clearHead || !settledHead || !ball || !device || !rig || !whole || !plunger || !body) return;
    if (hero.dataset.animation === 'false') return;
    var shaft = document.createElement('span');
    shaft.setAttribute('aria-hidden', 'true');
    shaft.style.cssText = 'position:absolute;display:block;visibility:hidden;background:linear-gradient(90deg,#b9000c,#f5222d 18%,#ef1423 80%,#a9000b);border-radius:0;pointer-events:none;';
    [18, 56].forEach(function (left) {
      var groove = document.createElement('span');
      groove.style.cssText = 'position:absolute;top:3%;bottom:5%;left:' + left + '%;width:26%;border-radius:9px;background:linear-gradient(90deg,#8d0010,#f33c47 45%,#ff5660 70%,#b60013);box-shadow:inset 1px 1px 2px rgba(80,0,0,.5);';
      shaft.appendChild(groove);
    });
    rig.insertBefore(shaft, plunger);

    var ready = false;
    var geometry = null;
    var frame = 0;
    var playbackProgress = 0;
    var completedScroll = false;
    var replayArmed = false;
    var lastScrollY = window.scrollY;

    function clamp(value) { return Math.max(0, Math.min(1, value)); }
    function phase(value, start, end) { return clamp((value - start) / (end - start)); }
    function ease(value) { return value * value * (3 - 2 * value); }
    function contain(width, height) {
      var scale = Math.min(width / 1024, height / 1536);
      return { scale: scale, x: (width - 1024 * scale) / 2, y: (height - 1536 * scale) / 2 };
    }
    function reset() {
      shaft.style.visibility = 'hidden';
      hero.classList.remove('is-scroll-hero', 'is-device-pulling');
      hero.style.removeProperty('--hero-scroll-height');
      hero.style.removeProperty('--hero-stage-height');
      hero.style.removeProperty('--hero-sticky-top');
      hero.style.removeProperty('--hero-scene-scale');
      [cluster, blockedHead, clearHead, settledHead, ball, rig, plunger, body].forEach(function (element) { element.removeAttribute('style'); });
      geometry = null;
    }
    function measure() {
      if (!alive) return;
      header = realDocument.querySelector('.site-header');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var availableHeight = window.innerHeight - headerBottom;
      if (motionPreference.matches || availableHeight < 460) { reset(); return; }
      var mobileHero = window.innerWidth <= 600;
      var stageHeight = Math.min(mobileHero ? 640 : 740, availableHeight);
      hero.style.setProperty('--hero-stage-height', stageHeight + 'px');
      hero.classList.add('is-scroll-hero');

      // Short viewports keep the static hero so the title and CTA are never clipped.
      var stageStyle = window.getComputedStyle(stage);
      var fixedHeight = parseFloat(stageStyle.paddingTop) + parseFloat(stageStyle.paddingBottom);
      Array.prototype.forEach.call(stage.children, function (child) {
        var style = window.getComputedStyle(child);
        fixedHeight += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        if (child !== visual) fixedHeight += child.offsetHeight;
      });
      if (stageHeight < fixedHeight + 180) { reset(); return; }

      // All coordinates are measured before scene transforms, including contain letterboxing.
      var headImage = contain(blockedHead.offsetWidth, blockedHead.offsetHeight);
      var deviceScale = Math.max(whole.offsetWidth / 1254, whole.offsetHeight / 1254);
      var deviceImage = {scale: deviceScale, x: (whole.offsetWidth - 1254 * deviceScale) / 2, y: (whole.offsetHeight - 1254 * deviceScale) / 2};
      var deviceTransform = window.getComputedStyle(device).transform;
      var deviceShift = deviceTransform === 'none' ? 0 : Number(deviceTransform.split(',')[4]) || 0;
      var pivotX = deviceImage.x + 625 * deviceImage.scale;
      var pivotY = deviceImage.y + 1180 * deviceImage.scale;
      var deviceX = device.offsetLeft + rig.offsetLeft + deviceShift;
      var deviceY = device.offsetTop + rig.offsetTop;
      var mouthX = head.offsetLeft + headImage.x + 895 * headImage.scale;
      var mouthY = head.offsetTop + headImage.y + 710 * headImage.scale;
      var splitY = deviceImage.y + 250 * deviceImage.scale;
      shaft.style.left = (deviceImage.x + 580 * deviceImage.scale) + 'px';
      shaft.style.width = (90 * deviceImage.scale) + 'px';
      shaft.style.top = (splitY - 14 * deviceImage.scale) + 'px';
      rig.style.transformOrigin = pivotX + 'px ' + pivotY + 'px';
      plunger.style.clipPath = 'inset(0 0 ' + (whole.offsetHeight - splitY + deviceImage.scale) + 'px 0)';
      body.style.clipPath = 'inset(' + (splitY - deviceImage.scale) + 'px 0 0 0)';
      ball.style.width = (97 * headImage.scale / .75) + 'px';
      ball.style.left = '0';
      ball.style.top = '0';
      geometry = {
        start: 0,
        distance: Math.max(300, stageHeight * .8),
        mobile: mobileHero,
        head: headImage,
        device: deviceImage,
        pivotX: pivotX,
        pivotY: pivotY,
        deviceX: deviceX,
        deviceY: deviceY,
        moveX: mouthX - deviceX - pivotX,
        moveY: mouthY - deviceY - pivotY,
        clusterWidth: cluster.offsetWidth,
        headRight: head.offsetLeft + blockedHead.offsetWidth,
        visualWidth: visual.offsetWidth,
        scale: Math.min(1, visual.offsetHeight / Math.max(cluster.offsetHeight, blockedHead.offsetHeight))
      };
      if (ready) render();
      else cluster.style.transform = 'translate(-50%, -50%) scale(' + geometry.scale + ')';
    }
    function render() {
      frame = 0;
      if (!geometry) return;
      var g = geometry;
      var progress = playbackProgress;
      var approach = ease(phase(progress, g.mobile ? 0 : .05, .27));
      var pull = ease(phase(progress, .31, .48));
      var release = ease(phase(progress, .41, .64));
      var clear = ease(phase(progress, .40, .43));
      var withdraw = ease(phase(progress, .56, .68));
      var returnHome = ease(phase(progress, .79, .94));
      var settled = ease(phase(progress, .84, .96));
      var pose = approach * (1 - returnHome);
      var angle = pose * Math.PI / 2;
      var devicePoseScale = 1 - .26 * pose;
      // First leave room in front of the lips, then return to the exact initial pose.
      var dx = g.moveX * pose + 300 * g.head.scale * withdraw * (1 - returnHome);
      var dy = g.moveY * pose;
      rig.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) rotate(' + (pose * 90) + 'deg) scale(' + devicePoseScale + ')';
      var extension = 470 * g.device.scale * pose * pull;
      hero.classList.toggle('is-device-pulling', extension > 0);
      plunger.style.transform = 'translateY(' + (-extension) + 'px)';
      shaft.style.height = (extension + 28 * g.device.scale) + 'px';
      shaft.style.transform = 'translateY(' + (-extension) + 'px)';
      shaft.style.visibility = extension > 0 ? 'visible' : 'hidden';

      // Center the moving assembly and keep its full horizontal reach inside mobile screens.
      var left = 0;
      var right = g.headRight;
      [g.device.x, g.device.x + 1254 * g.device.scale].forEach(function (x) {
        [g.device.y - extension, g.device.y + 1254 * g.device.scale].forEach(function (y) {
          var rotatedX = g.deviceX + g.pivotX + dx + devicePoseScale * (Math.cos(angle) * (x - g.pivotX) - Math.sin(angle) * (y - g.pivotY));
          left = Math.min(left, rotatedX);
          right = Math.max(right, rotatedX);
        });
      });
      var scale = Math.min(g.scale, (g.visualWidth - 24) / (right - left));
      var shift = (g.clusterWidth / 2 - (left + right) / 2) * pose;
      cluster.style.transform = 'translate(-50%, -50%) scale(' + scale + ') translateX(' + shift + 'px)';
      hero.style.setProperty('--hero-scene-scale', scale);

      // Follow the airway to the lips, then visibly exit through the gap left by the mask.
      var t = release;
      var u = 1 - t;
      var sourceX = u * u * u * 561 + 3 * u * u * t * 545 + 3 * u * t * t * 790 + t * t * t * 940;
      var sourceY = u * u * u * 775 + 3 * u * u * t * 650 + 3 * u * t * t * 696 + t * t * t * 752;
      var exit = ease(phase(progress, .64, .75));
      var fall = ease(phase(progress, .75, .83));
      sourceX += 210 * exit - 60 * fall;
      sourceY += 30 * exit + 330 * fall;
      var x = g.head.x + sourceX * g.head.scale;
      var y = g.head.y + sourceY * g.head.scale;
      blockedHead.style.opacity = 1 - clear;
      clearHead.style.opacity = clear * (1 - settled);
      settledHead.style.opacity = settled;
      ball.style.opacity = clear * (1 - ease(phase(progress, .79, .84)));
      ball.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%, -50%) scale(' + (1 - release * .12) + ')';
    }
    function schedule() {
      var y = Math.max(0, window.scrollY);
      var upward = y < lastScrollY;
      var downward = y > lastScrollY;
      lastScrollY = y;
      if (upward && y <= 1) replayArmed = true;
      if (replayArmed && downward) {
        completedScroll = false;
        replayArmed = false;
        playbackProgress = 0;
      }
      if (!ready || !geometry || completedScroll || !downward) return;
      // Advance only with downward scrolling; no timer, pinning, or layout reset.
      playbackProgress = Math.max(playbackProgress, clamp((y - geometry.start) / geometry.distance));
      if (playbackProgress >= 1) completedScroll = true;
      if (!frame) frame = window.requestAnimationFrame(render);
    }
    function decoded(image) {
      if (image.decode) return image.decode();
      return new Promise(function (resolve, reject) {
        if (image.complete) { image.naturalWidth ? resolve() : reject(); return; }
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', reject, { once: true });
      });
    }
    // Establish a fixed stage without a scroll runway or sticky positioning.
    measure();
    Promise.all([blockedHead, clearHead, settledHead, ball, whole, plunger, body].map(decoded)).then(function () {
      if (!alive) return;
      ready = true;
      measure();
      schedule();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', measure, { passive: true });
      if (motionPreference.addEventListener) motionPreference.addEventListener('change', measure);
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(measure);
        if (header) observer.observe(header);
        observer.observe(hero.querySelector('.selected-hero__copy'));
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    }).catch(reset);
  }

  function initMenu() {
    var button = document.querySelector('.menu-toggle');
    var nav = document.querySelector('.nav-links');
    if (!button || !nav) return;
    var originalMenuHTML=button.innerHTML;
    var openLabel=button.dataset.menuOpenLabel||button.getAttribute('aria-label');
    var closeLabel=button.dataset.menuCloseLabel||openLabel;
    var dropdowns = nav.querySelectorAll('.nav-dropdown');
    function closeDropdowns(except) {
      dropdowns.forEach(function (dropdown) { if (dropdown !== except) dropdown.open = false; });
    }
    button.addEventListener('click', function () {
      var open = !nav.classList.contains('open');
      if (!open) closeDropdowns();
      nav.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      syncBuybarModalState();
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? closeLabel : openLabel);
      if(open)button.textContent='×';else button.innerHTML=originalMenuHTML;
    });
    function closeMenu() {
      closeDropdowns();
      nav.classList.remove('open');
      document.body.classList.remove('menu-open');
      syncBuybarModalState();
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', openLabel);
      button.innerHTML = originalMenuHTML;
    }
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { window.setTimeout(closeMenu, 0); });
    });
    document.addEventListener('click', function (event) {
      dropdowns.forEach(function (dropdown) {
        if (!dropdown.contains(event.target)) dropdown.open = false;
      });
    });
    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('toggle', function () {
        if (dropdown.open) closeDropdowns(dropdown);
      });
      dropdown.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !dropdown.contains(event.relatedTarget)) dropdown.open = false;
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var expanded = nav.querySelector('.nav-dropdown[open]');
      if (expanded) {
        event.preventDefault();
        closeDropdowns();
        expanded.querySelector('summary').focus();
      } else if (nav.classList.contains('open')) {
        closeMenu();
        button.focus();
      }
    });
    var mobileMenu = window.matchMedia('(max-width: 980px)');
    if (mobileMenu.addEventListener) mobileMenu.addEventListener('change', closeMenu);
  }

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-image]').forEach(function (button) {
      button.addEventListener('click', function () {
        main.src = button.dataset.image;
        gallery.querySelectorAll('[data-image]').forEach(function (thumb) { thumb.setAttribute('aria-current', 'false'); });
        button.setAttribute('aria-current', 'true');
      });
    });
  }

  function initScenarioSlider() {
    var slider = document.querySelector('[data-scenario-slider]');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.scenario-slide'));
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var active = 0;
    var timer = null;

    function showNext() {
      slides[active].classList.remove('is-active');
      active = (active + 1) % slides.length;
      slides[active].classList.add('is-active');
    }

    function start() {
      if (!timer && !document.hidden) timer = window.setInterval(showNext, Number(slider.dataset.interval || 2000));
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) start();
        else stop();
      }, { threshold: .15 }).observe(slider);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
  }

  function initFirstAidSlider() {
    document.querySelectorAll('[data-first-aid-slider]').forEach(function(slider){
    if (!slider) return;
    var slides = slider.querySelectorAll('.first-aid-slide');
    if (slides.length < 2) return;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visible = !('IntersectionObserver' in window);
    var active = 0;
    var timer = null;

    function syncPlayback() {
      window.clearInterval(timer);
      timer = null;
      if (!visible || document.hidden || motion.matches) return;
      timer = window.setInterval(function () {
        var next = (active + 1) % slides.length;
        if (!slides[next].complete || !slides[next].naturalWidth) return;
        slides[active].classList.remove('is-active');
        slides[next].classList.add('is-active');
        active = next;
      }, Number(slider.dataset.interval || 2000));
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        syncPlayback();
      }, { threshold: .15 }).observe(slider);
    }
    document.addEventListener('visibilitychange', syncPlayback);
    if (motion.addEventListener) motion.addEventListener('change', syncPlayback);
    syncPlayback();
    });
  }

  function initReviewCarousel() {
    var track = document.querySelector('[data-review-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.quote-card'));
    var previous = document.querySelector('[data-review-prev]');
    var next = document.querySelector('[data-review-next]');
    if (!cards.length || !previous || !next) return;
    var active = 0;
    var ticking = false;

    function nearestCard() {
      var closest = 0;
      var distance = Infinity;
      cards.forEach(function (card, index) {
        var currentDistance = Math.abs(card.offsetLeft - track.scrollLeft);
        if (currentDistance < distance) {
          distance = currentDistance;
          closest = index;
        }
      });
      return closest;
    }

    function update() {
      active = nearestCard();
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      ticking = false;
    }

    function goTo(index) {
      active = Math.max(0, Math.min(cards.length - 1, index));
      track.scrollTo({ left: cards[active].offsetLeft, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { goTo(nearestCard() - 1); });
    next.addEventListener('click', function () { goTo(nearestCard() + 1); });
    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(nearestCard() - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(nearestCard() + 1); }
    });
    window.addEventListener('resize', update);
    update();
  }

  function initExplainerVideo() {
    document.querySelectorAll('[data-explainer-player]').forEach(function (player) {
      var video = player.querySelector('video');
      var play = player.querySelector('[data-explainer-play]');
      if (player.dataset.youtubeId && play) {
        play.hidden = false;
        play.addEventListener('click', function () {
          if (player.querySelector('iframe')) return;
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(player.dataset.youtubeId) + '?autoplay=1&playsinline=1&rel=0';
          iframe.title = player.dataset.videoTitle || 'LifeSaveAir Erklärvideo';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          player.appendChild(iframe);
          play.hidden = true;
          var poster = player.querySelector('.explainer-player__poster');
          if (poster) poster.hidden = true;
          iframe.focus();
        });
        return;
      }
      if (!video || !play) return;
      play.hidden = false;
      video.addEventListener('play', function () { play.hidden = true; });
      play.addEventListener('click', function () {
        var playback = video.play();
        if (playback && playback.catch) playback.catch(function () {
          // Leave the native controls available if the browser cannot start playback.
          play.hidden = true;
        });
        video.focus();
      });
    });
  }

  initShippingBar();initScrollHero();initMenu();initGallery();initScenarioSlider();initFirstAidSlider();initReviewCarousel();initExplainerVideo();
  mounted.set(root,()=>{alive=false;abort.abort();disposers.forEach(fn=>fn());intervals.forEach(clearInterval);timeouts.forEach(clearTimeout);frames.forEach(cancelAnimationFrame);root.querySelectorAll('video').forEach(video=>video.pause());});
 }
 realDocument.querySelectorAll('.shopify-section').forEach(mount);
 realDocument.addEventListener('shopify:section:load',event=>{mount(event.target);realWindow.dispatchEvent(new Event('resize'));});
 realDocument.addEventListener('shopify:section:unload',event=>{mounted.get(event.target)?.();mounted.delete(event.target);});
 realDocument.addEventListener('shopify:block:select',event=>{
  const details=event.target.closest('details');if(details)details.open=true;
  const card=event.target.closest('.quote-card');if(card)card.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
 });
})();
